import { render } from "./Soporte.vue?vue&type=template&id=e892c382&scoped=true"
import script from "./Soporte.vue?vue&type=script&lang=js"
export * from "./Soporte.vue?vue&type=script&lang=js"

import "./Soporte.vue?vue&type=style&index=0&id=e892c382&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e892c382"]])

export default __exports__